import React from 'react'
import { checkTextTranslation, imageAddress, translate } from '../../utils/useful'
import Modal from '../Modal'
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import ItemModal from '../../modals/ItemModal';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { nanoid } from 'nanoid';
import HttpServices from '../../utils/Http.services';
import SlideView from './SlideView';

// fake data generator
// const getItems = count =>
//     Array.from({ length: count }, (v, k) => k).map(k => ({
//         id: `item-${k}`,
//         content: `item ${k}`
//     }));

// a little function to help us with reordering the result
const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
};

const grid = 8;

const getItemStyle = (isDragging, draggableStyle) => ({
    // some basic styles to make the items look a bit nicer
    userSelect: "none",
    padding: 10,
    margin: `0 0 ${grid}px 0`,
    direction: 'rtl',

    // change background colour if dragging
    background: isDragging ? "lightblue" : "#f0f0f0",
    borderRadius: 6,
    // styles we need to apply on draggables
    ...draggableStyle
});

const getListStyle = isDraggingOver => ({
    background: isDraggingOver ? "#ddd" : "#fff",
    padding: grid,
    width: '100%',
    borderRadius: 8
});



class SlidesInput extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            items: [],
            headers: [
                // { key: 'image', type: 'ImageInput', col: '12', information: { label: '{{lang}}image', single: true, cropper: true, ratio: '1:1', placeholder: '{{lang}}chooseImage', required: true }, showMain: true },
                // { col: '12', key: 'title', type: 'TextInput', information: { label: 'title', disabled: false, required: true }, showMain: true, inExport: true },
            ],
            currentViewIndex: 0,
            options: [
                { label: 'اسلاید متنی', key: 'text', icon: '/images/carrow.svg' },
                { label: 'اسلاید صوتی', key: 'audio', icon: '/images/carrow.svg' },
                { label: 'اسلاید ویدیو', key: 'video', icon: '/images/carrow.svg' },
                { label: 'اسلاید تست', key: 'test', icon: '/images/carrow.svg' },
                { label: 'اسلاید جواب تست', key: 'testResult', icon: '/images/carrow.svg' },

            ]
        };
    }

    onDragEnd = (result) => {
        // dropped outside the list
        if (!result.destination) {
            return;
        }

        const items = reorder(
            this.props.data,
            result.source.index,
            result.destination.index
        );

        this.changeInputValue(items)

        this.setState({
            items
        });
    }

    changeInputValue(value) {
        // let value = (target.validity.valid) ? target.value : null
        // if (value !== null) {
        this.props.changeValue(this.props.header.key, value, this.props.extra)
        // }
    }

    openModal = () => {
        this.modal.showModal()
    }

    openViewModal = () => {
        this.viewModal.showModal()
        this.setState({currentViewIndex:0})
    }

    openSelectOptionsModel = () => {
        this.selectOptionsModal.showModal()

    }


    openNewItem = (type, item, index) => {
        // console.log(prop)
        this.itemModal.modal.showModal()
        this.selectOptionsModal.hideModal()

        // console.log(item)
        // console.log(prop)

        // let type = item?.type ?? prop.type

        console.log(type)

        this.setState({ currentType: type, currentItem: item, currentIndex: index })

        let headers = []

        if (type == 'text') {
            headers = [
                // { key: 'image', type: 'ImageInput', col: '12', information: { label: '{{lang}}image', single: true, cropper: true, ratio: '1:1', placeholder: '{{lang}}chooseImage', required: true }, showMain: true },
                { col: '12', key: 'title', type: 'TextInput', information: { label: 'عنوان', disabled: false, required: false }, showMain: true, inExport: true },
                { col: '12', key: 'description', type: 'TextAreaInput', information: { label: 'توضیحات', disabled: false, required: true }, showMain: true, inExport: true },

            ]
        }


        if (type == 'audio') {
            headers = [
                { col: '12', key: 'title', type: 'TextInput', information: { label: 'عنوان', disabled: false, required: false }, showMain: true, inExport: true },
                { col: '12', key: 'description', type: 'TextAreaInput', information: { label: 'توضیحات', disabled: false, required: true }, showMain: true, inExport: true },
                { col: '12', key: 'audio', type: 'FileInput', information: { label: 'فایل صوتی', disabled: false, required: true }, showMain: true, inExport: true },
            ]
        }

        if (type == 'video') {
            headers = [
                { col: '12', key: 'title', type: 'TextInput', information: { label: 'عنوان', disabled: false, required: false }, showMain: true, inExport: true },
                { col: '12', key: 'video', type: 'FileInput', information: { label: 'فایل ویدیو', disabled: false, required: true }, showMain: true, inExport: true },
            ]
        }

        if (type == 'test') {
            headers = [
                { col: '12', key: 'title', type: 'TextInput', information: { label: 'عنوان', disabled: false, required: false }, showMain: true, inExport: true },
                { col: '12', key: 'question', type: 'TextInput', information: { label: 'صورت سوال', disabled: false, required: true }, showMain: true, inExport: true },
                {
                    type: 'SubformInput',
                    key: 'options',
                    col: '12',
                    information: {
                        headers: [
                            { type: 'TextInput', key: 'name', col: '8', information: { label: '{{lang}}گزینه', placeholder: '{{lang}}گزینه', required: true }, showMain: true, },
                            { type: 'NumberInput', key: 'score', col: '4', information: { label: '{{lang}}امتیاز گزینه', placeholder: '{{lang}}امتیاز گزینه', required: true }, showMain: true, },
                        ],
                        placeholder: '{{lang}}placeholders.insertInformation',
                        required: false,
                    },
                    showMain: true
                },
            ]
        }

        if (type == 'testResult') {
            headers = [
                { col: '12', key: 'title', type: 'TextInput', information: { label: 'عنوان', disabled: false, required: false }, showMain: true, inExport: true },
                {
                    type: 'SubformInput',
                    key: 'options',
                    col: '12',
                    information: {
                        headers: [
                            { type: 'NumberInput', key: 'score', col: '8', information: { label: '{{lang}}توضیح نتیجه', placeholder: '{{lang}}توضیح نتیجه', required: true }, showMain: true, },
                            { type: 'NumberInput', key: 'result', col: '4', information: { label: '{{lang}}امتیاز کل', placeholder: '{{lang}}امتیاز کل', required: true }, showMain: true, },

                        ],
                        placeholder: '{{lang}}placeholders.insertInformation',
                        required: false,
                    },
                    showMain: true
                },
            ]
        }



        let colorHeaders = [
            { col: '12', key: 'backgroundColor', type: 'ColorGradientInput', information: { label: 'رنگ پس زمینه', disabled: false, required: false }, showMain: true, inExport: true },
            { col: '12', key: 'backgroundImage', type: 'ImageInput', information: { label: 'تصویر پس زمینه', disabled: false, single: true, cropper: true, ratio: '9:16', required: false }, showMain: true, inExport: true },
            { col: '12', key: 'textColor', type: 'ColorInput', information: { label: 'رنگ متن', disabled: false, single: true, cropper: true, ratio: '9:16', required: false }, showMain: true, inExport: true },
        ]


        let finalHeaders = [...headers, ...colorHeaders]

        this.setState({ headers: finalHeaders })
        // if()
        // let items = this.props.data
        // items.push({ type: 'text', id: nanoid() })
        // this.setState({ items })
    }



    addNewItem = () => {
        // this.selectOptionsModal.hideModal()

        let items = this.props.data
        items.push({ type: this.state.currentType, id: nanoid() })
        this.setState({ items })
    }

    submitForm = (data) => {


        // console.log(data)

        this.setState({ isPostingData: true, })
        HttpServices.handleFiles(null, data, () => {

            this.setState({ isPostingData: false })

            // console.log(data)
            let slides = this.props.data
            // console.log(slides)
            if (!Array.isArray(slides)) {
                slides = []
            }

            data.id = nanoid()
            data.type = this.state.currentType

            // console.log(this.state.currentType)

            if (this.state.currentIndex != null) {
                slides[this.state.currentIndex] = data
            } else {
                slides.push(data)
            }

            this.itemModal.modal.hideModal()

            this.changeInputValue(slides)

            this.setState({ currentItem: null })
        })


    }

    removeItem = (index) => {
        let slides = this.props.data
        slides.splice(index, 1)
        this.changeInputValue(slides)

    }


    render() {

        var sliderSettings = {
            dots: true,
            autoplay: false,
            autoplaySpeed: 2500,
            infinite: false,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            initialSlide: 0,
            arrows: false

        };

        return (
            <div className="w-100 h-100" >
                {/* <input  ref={el => this.input = el} spellCheck={this.props.header.information.spellCheck} value={this.props.data ? this.props.data : ''} onChange={(e) => this.changeInputValue(e.target)} placeholder={checkTextTranslation(this.props.header.information.placeholder)} disabled={this.props.disabled || this.props.header.information?.disabled} className="transpanet-input" /> */}
                <p onClick={() => this.openModal()} className='cursor-pointer '>{this.props.data?.length + ' اسلاید'} </p>

                <Modal ref={el => this.modal = el} maxWidth={600}>
                    <div className='px-3 pt-3' style={{ direction: 'rtl', backgroundColor: '#fff', borderRadius: 8, paddingBottom: 100 }}>
                        <div className='px-2 w-100 flexcb'>
                            <p className='text-right mb-3 text-bold mt-2' style={{ fontSize: 18 }}>لیست اسلایدها</p>
                            <button onClick={() => this.openViewModal()} className=' py-2 px-3' style={{ backgroundColor: '#000', color: '#fff', borderRadius: 6 }}>
                                <p className='text-bold ' style={{ fontWeight: 600, fontSize: 14 }}>نمایش اسلایدها</p>
                            </button>
                        </div>

                        <DragDropContext onDragEnd={this.onDragEnd}>
                            <Droppable droppableId="droppable">
                                {(provided, snapshot) => (
                                    <div
                                        {...provided.droppableProps}
                                        ref={provided.innerRef}
                                        style={getListStyle(snapshot.isDraggingOver)}
                                    >
                                        {this.props.data?.map((item, index) => {
                                            // console.log(item.id)
                                            return (
                                                <Draggable key={item.id} draggableId={item.id} index={index}>
                                                    {(provided, snapshot) => (
                                                        <div
                                                            ref={provided.innerRef}
                                                            {...provided.draggableProps}
                                                            {...provided.dragHandleProps}
                                                            style={getItemStyle(
                                                                snapshot.isDragging,
                                                                provided.draggableProps.style
                                                            )}
                                                        >
                                                            <div className='w-100 flexc'>

                                                                <div>
                                                                    <div className=' d-flex flex-column' style={{ height: 60, width: 60, borderRadius: 40, background: (item.backgroundImage ? ("url(" + imageAddress(item.backgroundImage) + ")") : (item.backgroundColor ?? 'linear-gradient(#0d9488, #ff3030)')), backgroundSize: 'cover', backgroundPosition: 'center', }}>

                                                                    </div>
                                                                </div>


                                                                <div className='pr-2 w-100'>

                                                                    <div className='flexcb'>

                                                                        {item.title ? (
                                                                            <div className='mt-1' style={{ flex: 1 }}>
                                                                                <p className='text-small text-bold text-bold'>{item.title}</p>
                                                                            </div>
                                                                        ) : (<div></div>)}


                                                                        <div className='flexc'>



                                                                            <button className='mx-1 p-0 flexcc'>
                                                                                <img src={'/images/remove.svg'} height={20} onClick={() => this.removeItem(index)} />
                                                                            </button>

                                                                            <button className='mx-1 p-0 flexcc' onClick={() => this.openNewItem(item.type, item, index)}>
                                                                                <img src={'/images/inputdef.svg'} height={20} />
                                                                            </button>

                                                                            {item.type && (
                                                                                <div className='mx-1  d-flex'>
                                                                                    <div className='px-3 py-1' style={{ backgroundColor: '#fff', borderRadius: 40 }}>
                                                                                        <p className='text-smaller '>{translate(item.type)}</p>
                                                                                    </div>
                                                                                </div>
                                                                            )}



                                                                        </div>

                                                                    </div>

                                                                    {item.question && (
                                                                        <div className='text-smaller mt-1' style={{ flex: 2 }}>
                                                                            <p>{item.question}</p>
                                                                        </div>

                                                                    )}

                                                                    {item.description && (
                                                                        <div className='text-smaller mt-1' style={{ flex: 2 }}>
                                                                            <p>{item.description}</p>
                                                                        </div>

                                                                    )}
                                                                </div>
                                                                {/* <div style={{ flex: 3 }}>
                                                                    Lorem ipsum dolor, sit amet consectetur adipisicing elit. Fugiat labore reprehenderit temporibus quae placeat aliquam neque aut eligendi eius, ullam sequi iste nam excepturi commodi impedit fugit vero ducimus praesentium.
                                                                </div> */}
                                                                {/* {item.content} */}
                                                            </div>
                                                        </div>
                                                    )}
                                                </Draggable>
                                            )
                                        }
                                        )}
                                        {provided.placeholder}
                                    </div>
                                )}
                            </Droppable>


                        </DragDropContext>


                        {this.props.data?.length == 0 && (
                            <p className='text-center'>در حال حاضر اسلایدی برای این اپیزود موجود نمی باشد</p>
                        )}
                        <div className='px-2 w-100 mt-4'>
                            <button className=' py-3 px-3 w-100' onClick={() => this.openSelectOptionsModel()} style={{ backgroundColor: '#000', color: '#fff', borderRadius: 6 }}>
                                <p className='text-bold ' style={{ fontWeight: 600, fontSize: 18 }}>+ افزودن اسلاید</p>
                            </button>
                        </div>


                    </div>
                </Modal>


                <Modal ref={el => this.selectOptionsModal = el} maxWidth={250}>
                    <div className='px-3 pt-3' style={{ direction: 'rtl', backgroundColor: '#fff', borderRadius: 8, paddingBottom: 20 }}>
                        <p className='mb-4'>قصد افزودن چه نوع اسلایدی را دارید؟</p>
                        {this.state.options.map((prop, index) => {
                            return (
                                <button onClick={() => this.openNewItem(prop.key)} className='flexc w-100 pb-3 mb-2' style={{ fontSize: 18, borderBottom: '1px solid #f2f2f2' }}>
                                    <img className='reverse' height={16} src={prop.icon} />
                                    <p className='text-bold mx-2'>{prop.label}</p>
                                </button>
                            )
                        })}
                    </div>
                </Modal>


                <Modal ref={el => this.viewModal = el} maxWidth={350} dontHideOnOverlay={true}>
                    <div className='px-3 pt-3' style={{ direction: 'rtl', backgroundColor: '#fff', borderRadius: 8, paddingBottom: 50 }}>

                        <div style={{ borderRadius: 8, overflow: 'hidden' }}>

                            <div className='flexc w-100 mb-1'>
                                {this.props.data?.map((item, index) => {
                                    return (
                                        <div className='cursor-pointer' onClick={() => this.slider.slickGoTo(this.props.data?.length - 1 - index)} style={{ flex: 1, height: 5, margin: 1, backgroundColor: index == (this.props.data?.length - 1 - this.state.currentViewIndex) ? '#ccc' : '#eee', borderRadius: 2 }}></div>
                                    )
                                })}
                            </div>


                            <Slider ref={el => this.slider = el} {...sliderSettings} afterChange={e => { this.setState({ currentViewIndex: e }) }}>
                                {this.props.data?.map((item, index) => {
                                    // console.log(item.backgroundImage)
                                    // console.log("url(" + imageAddress(item.backgroundImage) + ")")
                                    return (
                                        <SlideView data={item} key={index} />
                                    )
                                })}
                            </Slider>
                        </div>
                    </div>
                </Modal>


                <ItemModal
                    ref={el => this.itemModal = el}
                    page={this.props.page}
                    headers={this.state.headers}
                    initData={this.state.currentItem}
                    submitForm={this.submitForm}
                    isPostingData={this.state.isPostingData}
                />


            </div>
        )
    }
}

export default SlidesInput;